export const NavigationColor = {
  BRAND: 'brand',
  KAKI: 'kaki',
  SKY: 'sky',
  GREEN: 'green',
  PURPLE: 'purple',
  BLUE: 'blue',
  ORANGE: 'orange',
  RED: 'red',
  DEEP_GREEN: 'deep-green',
  DEEP_PURPLE: 'deep-purple',
  PINK: 'pink'
} as const

export type NavigationColor = (typeof NavigationColor)[keyof typeof NavigationColor]

export const navColorSelectedClass = (color: NavigationColor) => {
  switch (color) {
    case NavigationColor.BRAND:
      return 'bg-fill-brand'
    case NavigationColor.KAKI:
      return 'bg-fill-selected-kaki'
    case NavigationColor.SKY:
      return 'bg-fill-selected-sora'
    case NavigationColor.GREEN:
      return 'bg-fill-selected-green'
    case NavigationColor.PURPLE:
      return 'bg-fill-selected-purple'
    case NavigationColor.BLUE:
      return 'bg-fill-selected-blue'
    case NavigationColor.ORANGE:
      return 'bg-fill-selected-orange'
    case NavigationColor.RED:
      return 'bg-fill-selected-red'
    case NavigationColor.DEEP_GREEN:
      return 'bg-fill-selected-deep-green'
    case NavigationColor.DEEP_PURPLE:
      return 'bg-fill-selected-deep-purple'
    case NavigationColor.PINK:
      return 'bg-fill-selected-pink'
    default:
      return ''
  }
}

export const navColorClass = (color: NavigationColor) => {
  switch (color) {
    case NavigationColor.BRAND:
      return 'bg-fill-brand'
    case NavigationColor.KAKI:
      return 'bg-fill-kaki'
    case NavigationColor.SKY:
      return 'bg-fill-sora'
    case NavigationColor.GREEN:
      return 'bg-fill-green'
    case NavigationColor.PURPLE:
      return 'bg-fill-purple'
    case NavigationColor.BLUE:
      return 'bg-fill-blue'
    case NavigationColor.ORANGE:
      return 'bg-fill-orange'
    case NavigationColor.RED:
      return 'bg-fill-red'
    case NavigationColor.DEEP_GREEN:
      return 'bg-fill-deep-green'
    case NavigationColor.DEEP_PURPLE:
      return 'bg-fill-deep-purple'
    case NavigationColor.PINK:
      return 'bg-fill-pink'
    default:
      return ''
  }
}

export const navIconColorSelectChildClass = (color: NavigationColor) => {
  switch (color) {
    case NavigationColor.BRAND:
      return 'bg-surface-brand'
    case NavigationColor.KAKI:
      return 'bg-fill-selected-child-kaki'
    case NavigationColor.SKY:
      return 'bg-fill-selected-child-sora'
    case NavigationColor.GREEN:
      return 'bg-fill-selected-child-green'
    case NavigationColor.PURPLE:
      return 'bg-fill-selected-child-purple'
    case NavigationColor.BLUE:
      return 'bg-fill-selected-child-blue'
    case NavigationColor.ORANGE:
      return 'bg-fill-selected-child-orange'
    case NavigationColor.RED:
      return 'bg-fill-selected-child-red'
    case NavigationColor.DEEP_GREEN:
      return 'bg-fill-selected-child-deep-green'
    case NavigationColor.DEEP_PURPLE:
      return 'bg-fill-selected-child-deep-purple'
    case NavigationColor.PINK:
      return 'bg-fill-selected-child-pink'
    default:
      return ''
  }
}
